import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { x } from '@xstyled/styled-components';

export function Link({ children, external, ...otherProps }) {
  return (
    <x.a
      as={external ? 'a' : GatsbyLink}
      textDecoration="none"
      color="inherit"
      {...otherProps}
    >
      {children}
    </x.a>
  );
}
